import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import priceTypes from "astrid-firestore/src/api/prices/constants/priceTypes";

// Expenses call the production type "subcontractor" instead of "studio".
export default function usePriceTypes(expense = false) {
	const { t } = useTranslation();

	return useMemo(
		() => ({
			[priceTypes.CUSTOM]: t("priceCustom", "Custom"),
			[priceTypes.EDIT]: t("priceEdit"),
			[priceTypes.PROOF]: t("priceProof"),
			[priceTypes.EXTRA]: t("priceExtra"),
			[priceTypes.RECORD]: t("priceRecord"),
			[priceTypes.MANAGE]: t("priceManage"),
			[priceTypes.READER]: t("priceNarration"),
			[priceTypes.PRODUCTION]: expense ? t("priceSubcontractor") : t("priceProduction", "Studio"),
			[priceTypes.CLOUD_START_FEE_AUDIO]: t("priceCloudStartFeeAudio", "Cloud start fee: Audiobook or podcast"),
			[priceTypes.CLOUD_START_FEE_EBOOK]: t("priceCloudStartFeeEbook", "Cloud start fee: Ebook"),
			[priceTypes.CLOUD_REVENUE_LIVE]: t("priceCloudRevenueLive", "Cloud revenue: Live work"),
			[priceTypes.CLOUD_REVENUE_INACTIVE]: t("priceCloudRevenueInactive", "Cloud revenue: Inactive work"),
		}),
		[expense, t],
	);
}
